export default __webpack_public_path__ + "static/media/extra_out_l4.7c86a877.svg";